import { Component } from '@angular/core';

@Component({
  selector: 'dm-app',
  templateUrl: 'app.component.html',
})
export class AppComponent {}
